import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router';
import Button from '@/components/button';
import ContainerCard from '@/components/container-card';
import {APP_PATH} from '@/constants/routes';
import {TrackingClickPrefix} from '@/services/analytics/analytics-types';
import {WEB_CLICK_TRACKING_KEY} from '@/services/analytics/web-click-tracking-key';

const NotFound: FunctionComponent = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();

  return (
    <ContainerCard className="mt-40 h-fit">
      <div className="mx-auto pt-12 text-center">
        {/* eslint-disable-next-line i18next/no-literal-string */}
        <h1 className="mb-4 text-7xl font-extrabold tracking-tight text-violet lg:text-9xl">404</h1>
        <p className="mb-4 text-3xl font-bold text-black md:text-4xl">{t('routes.not-found.title')}</p>
        <p className="mb-8 text-lg">{t('routes.not-found.description')}</p>

        <div className="flex justify-center">
          <Button
            label={t('routes.not-found.button.label')}
            onClick={() => navigate(APP_PATH)}
            trackingKey={WEB_CLICK_TRACKING_KEY.NOT_FOUND_RETURN_HOME}
            trackingAs={TrackingClickPrefix.NAV}
          />
        </div>
      </div>
    </ContainerCard>
  );
};

export default NotFound;
